import {WidgetConfigurationObj} from './WidgetConfigurationObj';

export class WidgetEmb {
backgroundColor: string;
code: string;
cols: number;
fontColor: string;
hideBorders: boolean;
iconColor: string;
indice: number;
rows: number;
title: string;
uid: string;
wco: WidgetConfigurationObj;
widgetBackgroundColor: string;
x: number;
y: number;
}

